import { constraints, readOnly } from '@yola/ws-sdk';
import SpacerResezeTool from '../containers/spacer-resize-tool';

const spacerResizeToolSettings = {
  matches(element) {
    if (readOnly.verifiers.isReadOnlyModeEnabled()) {
      return false;
    }

    return element && constraints.verifiers.canBeSpaceResizable(element);
  },
  container: SpacerResezeTool,
};

export default spacerResizeToolSettings;
